import { render, staticRenderFns } from "./PuzzleWallsPage.vue?vue&type=template&id=4dd9de2a&"
import script from "./PuzzleWallsPage.vue?vue&type=script&lang=js&"
export * from "./PuzzleWallsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports